import { render, staticRenderFns } from "./IndexAdmin.vue?vue&type=template&id=18563ea3&scoped=true"
import script from "./IndexAdmin.vue?vue&type=script&lang=js"
export * from "./IndexAdmin.vue?vue&type=script&lang=js"
import style0 from "./IndexAdmin.vue?vue&type=style&index=0&id=18563ea3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18563ea3",
  null
  
)

export default component.exports